import { IAtendimentoFechado } from "../../../Interfaces/HelpDesk/Dashboard/DashboardInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GetDashboardInfoService() {
    return Service(
        Axios.get<Array<IAtendimentoFechado>>(
            `/helpdesk/dashboard/getdashboardinfor`
        )
    );
}
